import { Injectable, inject } from '@angular/core'
import { CanDeactivate } from '@angular/router'
import { Observable } from 'rxjs'
import { AuthService } from '../../services/auth.service'

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  private readonly authService = inject(AuthService)

  canDeactivate(component: CanComponentDeactivate): Observable<boolean> | Promise<boolean> | boolean {
    // The session is over (logout, expired token, idle timeout)
    if (this.authService.isLoggingOut) {
      return true
    }

    return component.canDeactivate ? component.canDeactivate() : true
  }
}
